// @flow
import * as React from 'react';
import Error from './error';
import Raven from 'raven-js';

type State = {
    hasError: boolean
};

type Props = {
    children: React.Element<any>,
    errorComponent?: React.Element<any>
};

export default class ErrorBoundary extends React.Component<Props, State> {
    static defaultProps: any;
    state = {
        hasError: false
    };

    componentDidCatch(error: typeof Error) {
        this.setState({ hasError: true });
        Raven.captureException(error);
    }

    render() {
        const { hasError } = this.state;
        const { children, errorComponent = <Error /> } = this.props;
        return hasError ? errorComponent : children;
    }
}



// WEBPACK FOOTER //
// ./src/components/error-boundary/index.js